/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Flux_HrefInputs */

const ja_home_brands_flux_href = /** @type {(inputs: Home_Brands_Flux_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://flux-event.com`)
};

const en_home_brands_flux_href = /** @type {(inputs: Home_Brands_Flux_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://flux-event.com`)
};

/**
* | output |
* | --- |
* | "https://flux-event.com" |
*
* @param {Home_Brands_Flux_HrefInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_flux_href = /** @type {((inputs?: Home_Brands_Flux_HrefInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Flux_HrefInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_flux_href(inputs)
	return en_home_brands_flux_href(inputs)
});